export default "__VITE_ASSET__f6fd3ad6__"